import { SignWrapperProps } from 'types';
import { SimpleHeader } from 'components/SimpleHeader';
import { Slider } from 'components/Slider';

import cx from 'classnames';
import styles from './SignWrapper.module.scss';

export const SignWrapper = ({
  slides,
  children,
  headerLink,
  headerLinkCaption,
  HeaderLinkDescription,
  linkId,
  footer,
}: SignWrapperProps) => {
  return (
    <>
      <div className={cx(styles.container, { [styles.withSlider]: !!slides })}>
        <div className={styles.mainContent}>
          <SimpleHeader
            caption={HeaderLinkDescription}
            linkCaption={headerLinkCaption}
            linkHref={headerLink}
            linkId={linkId}
          />
          {children && children}
        </div>
        {slides && <Slider customClass={styles.toggleableSlider} slides={slides} coverColor="#000" />}
      </div>
      {footer}
    </>
  );
};
